import {
  TStudentListParams,
  TStudentListResponse,
  TStudentDetailInfoResponse,
  TStudentChartListParams,
  TStudentChartListResponse,
  TCheckIsNeedPasswordResponse,
  TCourseListForRegisterChartResponse,
  TDeleteRegisteredRoundParams,
  TEditRegisteredRoundParams,
  TEvalautionChartForGradeParams,
  TEvalautionChartForGradeResponse,
  TEvaluationChartCountParams,
  TEvaluationChartCountResponse,
  TRegisteredRoundDetailResponse,
  TRegisteredRoundListParams,
  TRegisteredRoundListResponse,
  TRegisterRoundParams,
  TStatisticsByRoundParams,
  TStatisticsByRoundResponse,
  TStatisticsByStudentParams,
  TStatisticsByStudentResponse,
  TEvaluationChartFeedbackHistoryParams,
  TEvaluationChartFeedbackHistoryResponse,
  TChartInfoListByPatientResponse,
} from 'types/apis/professor';
import { createService } from './config/axios';
import qs from 'qs';
import { TEvaluationChartInfoResponse } from 'types/apis/chart/studentEvaluationChart';

// 학생 목록
export const getStudentList = async (params: TStudentListParams) => {
  const queryString = qs.stringify(params);
  const url = `/professor-student?${queryString}`;

  return await createService<TStudentListResponse>({
    url,
    options: {
      method: 'get',
    },
  });
};

// 학생 상세 - 기본 정보
export const getStudentDetailInfo = async (
  userId: number,
  courseInfoId: number
) =>
  await createService<TStudentDetailInfoResponse>({
    url: `/professor-student/default-detail/${userId}?courseInfoId=${courseInfoId}`,
    options: {
      method: 'get',
    },
  });

// 학생 상세 - 실습용 차트 목록
export const getStudentChartList = async (
  userId: number,
  params: TStudentChartListParams
) => {
  const queryString = qs.stringify(params);
  const url = `/professor-student/chart-detail/${userId}?${queryString}`;

  return await createService<TStudentChartListResponse>({
    url,
    options: {
      method: 'get',
    },
  });
};

// 회차 등록을 위한 강의 목록
export const getCourseListForRegisterChart = async () =>
  await createService<TCourseListForRegisterChartResponse>({
    url: '/professor-registered-chart/for-post',
    options: {
      method: 'get',
    },
  });

// 회차 등록
export const postRegisterRound = async (data: TRegisterRoundParams) =>
  await createService({
    url: '/professor-registered-chart',
    options: {
      method: 'post',
      data,
    },
  });

// 회차 목록
export const getRegisteredRoundList = async (
  params: TRegisteredRoundListParams
) => {
  const queryString = qs.stringify(params);
  const url = `/professor-registered-chart?${queryString}`;

  return await createService<TRegisteredRoundListResponse>({
    url,
    options: {
      method: 'get',
    },
  });
};

// 등록한 회차 상세 조회
export const getRegisteredRoundDetail = async (chartId: number) => {
  const url = `/professor-registered-chart/${chartId}`;

  return await createService<TRegisteredRoundDetailResponse>({
    url,
    options: {
      method: 'get',
    },
  });
};

// 등록한 회차 수정
export const putRegisteredRound = async (
  registeredChartId: number,
  data: TEditRegisteredRoundParams
) => {
  const url = `/professor-registered-chart/${registeredChartId}`;

  return await createService({
    url,
    options: {
      method: 'put',
      data,
    },
  });
};

// 등록된 회차 삭제를 위한 비밀번호 필요 여부 확인
export const getCheckIsNeedPasswordForDelete = async (chartId: number) => {
  const url = `/professor-registered-chart/delete-check/${chartId}`;

  return await createService<TCheckIsNeedPasswordResponse>({
    url,
    options: {
      method: 'get',
    },
  });
};

// 등록된 회차 삭제
export const deleteRegisteredRound = async (
  chartId: number,
  data?: TDeleteRegisteredRoundParams
) => {
  const url = `/professor-registered-chart/${chartId}`;
  return await createService({
    url,
    options: { method: 'delete', data },
  });
};

// 실습평가 > 현재 진행 상태
export const getEvaluationChartCount = async (
  params: TEvaluationChartCountParams
) => {
  const queryString = qs.stringify(params);
  const url = `/professor-chart-evaluate/evaluated-count?${queryString}`;

  return await createService<TEvaluationChartCountResponse>({
    url,
    options: {
      method: 'get',
    },
  });
};

// 실습평가 목록
export const getEvaluationChartListForGrade = async (
  params: TEvalautionChartForGradeParams
) => {
  const queryString = qs.stringify(params);
  const url = `/professor-chart-evaluate/list?${queryString}`;

  return await createService<TEvalautionChartForGradeResponse>({
    url,
    options: {
      method: 'get',
    },
  });
};

// 실습평가 서브 내비
export const getChartInfoListByPatient = async (evaluationChartId: number) => {
  const url = `/drop-down/professor/6-0-0?evaluationChartId=${evaluationChartId}`;

  return await createService<TChartInfoListByPatientResponse>({
    url,
    options: {
      method: 'get',
    },
  });
};

// 실습 차트 평가
export const postEvaluationChartFeedback = async (data: FormData) =>
  await createService({
    url: '/professor-feedback',
    options: {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      method: 'post',
      data,
    },
  });

// 실습 차트 평가 수정
export const putEvaluationChartFeedback = async (data: FormData) =>
  await createService({
    url: '/professor-feedback',
    options: {
      method: 'put',
      data,
    },
  });

// 실습용 차트 및 피드백 조회
export const getEvaluationChartForFeedback = async (
  evaluationChartId: number
) => {
  const url = `/professor-feedback/${evaluationChartId}`;

  return await createService<TEvaluationChartInfoResponse>({
    url,
    options: {
      method: 'get',
    },
  });
};

// 평가 이력 조회
export const getProfessorFeedbackHistory = async (
  params: TEvaluationChartFeedbackHistoryParams
) => {
  const queryString = qs.stringify(params);
  const url = `/professor-feedback/history?${queryString}`;

  return await createService<TEvaluationChartFeedbackHistoryResponse>({
    url,
    options: {
      method: 'get',
    },
  });
};

// 통계 - 학생 전체 조회
export const getStatisticsByRound = async (
  params: TStatisticsByRoundParams
) => {
  const queryString = qs.stringify(params);
  const url = `/professor-statistics?${queryString}`;

  return await createService<TStatisticsByRoundResponse>({
    url,
    options: {
      method: 'get',
    },
  });
};

// 통계 - 학생 개인 조회
export const getStatisticsByStudent = async (
  params: TStatisticsByStudentParams
) => {
  const queryString = qs.stringify(params);
  const url = `/professor-statistics/student?${queryString}`;

  return await createService<TStatisticsByStudentResponse>({
    url,
    options: {
      method: 'get',
    },
  });
};
